const FILTER_EXPLORER_EVOLUTION = 'explorer-evolution';
const FILTER_EXPLORER_CORRELATION = 'explorer-correlation';
const FILTER_EXPLORER_MULTIPLE_CORRELATION = 'explorer-multiple-correlation';

const filteredBreadcrumb = (context) => {
  let link = null;
  switch (context.filter) {
    default:
    case FILTER_EXPLORER_CORRELATION:
      link = '/explorer-correlation-variables';
      break;
    case FILTER_EXPLORER_EVOLUTION:
      link = '/explorer-evolution-variables';
      break;
    case FILTER_EXPLORER_MULTIPLE_CORRELATION:
      link = '/explorer-multiple-correlation-variables';
      break;
  }
  return [
    {name: context.$t('explorer.title'), link: '/explore'},
    {name: context.$t('explorer.parameterSelection'), link: link},
    {name: context.$t('query.title'), link: '/query/list?filter=' + context.filter},
    {name: context.$t('menu.correlation'), disabled: true}
  ];
};

export default {
  FILTER_EXPLORER_MULTIPLE_CORRELATION,
  FILTER_EXPLORER_EVOLUTION,
  FILTER_EXPLORER_CORRELATION,
  filteredBreadcrumb
};



// WEBPACK FOOTER //
// ./src/layouts/explorer/navigation.js